// SEO Audit Console Command
// Run this in browser console: window.runSEOAudit()

import SEOAudit from './seoAudit';

declare global {
    interface Window {
        runSEOAudit: () => void;
    }
}

// Make SEO audit available globally
window.runSEOAudit = function runSEOAudit(): void {
    const audit = new SEOAudit();
    void audit.runAudit();
};

// Auto-run on page load for development
if (process.env.NODE_ENV === 'development') {
    // Run: window.runSEOAudit() to start the audit
}

export default window.runSEOAudit;

